export enum ListingStatusEnum {
    UNKNOWN = 'UNKNOWN',
    LIVE = 'LIVE',
    DRAFT = 'DRAFT',
    PUBLISHING_IN_PROGRESS = 'DRAFT_PROCESSING',
    APPROVAL = 'DRAFT_WAITING_APPROVAL',
    FAILURES = 'DRAFT_PUBLISH_VALIDATION_ERRORS',
    REJECTED = 'DRAFT_REJECTED',
    REJECTED_WITH_COMMENTS = 'DRAFT_REJECTED_WITH_COMMENTS',
    BULK_PROCESSING = 'BULK_PROCESSING',
    NEW = 'NEW',
}

export enum ListingStatusBEEnum {
    UNKNOWN,
    LIVE,
    DRAFT,
    DRAFT_PROCESSING,
    DRAFT_WAITING_APPROVAL,
    DRAFT_PUBLISH_VALIDATION_ERRORS,
    DRAFT_REJECTED,
    DRAFT_REJECTED_WITH_COMMENTS,
    BULK_PROCESSING,
}

// Used to transform the BE enum to the enum name (the BE enum is sent in REST calls)
export const listingStatusMap: { [key in ListingStatusBEEnum]: ListingStatusEnum } = {
    [ListingStatusBEEnum.UNKNOWN]: ListingStatusEnum.UNKNOWN,
    [ListingStatusBEEnum.LIVE]: ListingStatusEnum.LIVE,
    [ListingStatusBEEnum.DRAFT]: ListingStatusEnum.DRAFT,
    [ListingStatusBEEnum.DRAFT_PROCESSING]: ListingStatusEnum.PUBLISHING_IN_PROGRESS,
    [ListingStatusBEEnum.DRAFT_WAITING_APPROVAL]: ListingStatusEnum.APPROVAL,
    [ListingStatusBEEnum.DRAFT_PUBLISH_VALIDATION_ERRORS]: ListingStatusEnum.FAILURES,
    [ListingStatusBEEnum.DRAFT_REJECTED]: ListingStatusEnum.REJECTED,
    [ListingStatusBEEnum.DRAFT_REJECTED_WITH_COMMENTS]: ListingStatusEnum.REJECTED_WITH_COMMENTS,
    [ListingStatusBEEnum.BULK_PROCESSING]: ListingStatusEnum.BULK_PROCESSING,
};
